import { render, staticRenderFns } from "./NotificationHandler.vue?vue&type=template&id=f2b16d8c&scoped=true&"
import script from "./NotificationHandler.vue?vue&type=script&lang=js&"
export * from "./NotificationHandler.vue?vue&type=script&lang=js&"
import style0 from "./NotificationHandler.vue?vue&type=style&index=0&id=f2b16d8c&prod&scoped=true&lang=css&"
import style1 from "./NotificationHandler.vue?vue&type=style&index=1&id=f2b16d8c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b16d8c",
  null
  
)

export default component.exports